










import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import UsersList from "@share/common/users-list/UsersList.vue";
import {Element} from "@api/models/Element";

import { DateTime, DurationObject, Interval } from 'luxon';

import { getCountdownData, getDurationObjectFromNow, CountdownData } from '../CountdownHelpers'

@Component({
    components: { UsersList }
})

export default class EventCountdown extends Vue {
    @Prop({ required: true }) event: Element | undefined;

    initialState: CountdownData = {
        days: '00',
        hours: '00',
        minutes: '00'
    }

    countdownData: CountdownData = this.initialState;

    coundownTimer: NodeJS.Timeout | null = null

    mounted() {
        this.setCountdown();
    }

    setCountdown() {

        if(this.isBegan) {
            this.countdownData = this.initialState;
        }
        else {
            this.coundownTimer = setInterval(() => this.updateTime(this.begin), this.COUNTDOWN_UPDATE_INTERVAL);
            this.updateTime(this.begin);
        }
    }

    updateTime(begin?: DateTime) {
        if(begin) {

            if(typeof begin === "string") {
                begin = DateTime.fromISO(begin);
            }

            const durationData = getDurationObjectFromNow(begin);

            if(this.isBegan || typeof durationData.minutes === "undefined") {
                this.countdownData = this.initialState;
            }

            this.countdownData = getCountdownData(durationData);
        }
    }

    @Watch('begin')
    watchBegin() {
        this.updateTime(this.begin);
    }

    beforeDestroy() {
        if(this.coundownTimer) {
            clearInterval(this.coundownTimer);
        }
    }

    get begin() {
        return this.event?.beginAt;
    }

    get isBegan() {
        return this.begin < DateTime.local().minus({minutes: 1}) || !this.begin;
    }

    get COUNTDOWN_UPDATE_INTERVAL() {
        return 59 * 1000;
    }
}
